import { Component, OnInit } from "@angular/core";
import { Inject, ViewChild } from "@angular/core";
import { DaoService } from "src/app/services/dao.service";
import { LstorageService } from "src/app/services/lstorage.service";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { EntityformComponent } from "../entityform/entityform.component";
import { DataSource } from "@angular/cdk/table";
import { NestedTreeControl } from "@angular/cdk/tree";
import { MatTreeNestedDataSource } from "@angular/material/tree";

import { SelectionModel } from "@angular/cdk/collections";
import { FlatTreeControl } from "@angular/cdk/tree";
import { AfterViewInit, Injectable } from "@angular/core";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
import { BehaviorSubject, Observable } from "rxjs";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import * as jwtDecode from "jwt-decode";
import { UserdeleteComponent } from "../userdelete/userdelete.component";
import { ToastService } from "src/app/services/toast.service";
import { MatDialog } from "@angular/material/dialog";
import { decryptData, encryptData } from "src/app/services/aes.service";

const LOAD_MORE = "LOAD_MORE";

const sinput = {
  apiGroupName: "{ApiGroupName}",
  searchParam: [
    {
      key: "PeopleFullName",
      value: "{Search Criteria}",
      entityType: "People",
    },
  ],
  conditionalParam: [],
  cases: [],
  repositories: [],
};

/** Nested node */
export class TodoItemNode {
  children: TodoItemNode[];
  sourceName: string;
  apiId: string;
  parentID: string;
}

export class TodoItemFlatNode {
  sourceName: string;
  level: number;
  expandable: boolean;
  apiId: string;
}

@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<TodoItemNode[]>([]);

  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }
  GroupId: any;
  apiGroupdata: any;
  constructor(
    private daoService: DaoService,
    private token: LstorageService,
    private toast: ToastService
  ) {
    this.initialize();
  }

  initialize() {
    this.GroupId = this.token.getGroupId();
    var data1 = {
      GroupId: this.GroupId,
    };
    this.daoService
      .getApiGroupById(encryptData(JSON.stringify(data1)))
      .subscribe((data: any) => {
        console.log("tree data");
        console.log(data);
        let userDetails = JSON.parse(decryptData(data.key));
        var d = [
          {
            groupId: "0",
            sourceName: "Parent",
            apiId: "0",
            parentID: "0",
            children: userDetails,
          },
        ];
        this.apiGroupdata = d;
        this.dataChange.next(this.apiGroupdata);
        console.log("final json");
        console.log(this.apiGroupdata);
      });
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `TodoItemNode`.
   */
  buildFileTree(obj: { [key: string]: any }, level: number): TodoItemNode[] {
    console.log("build tree");
    console.log(obj);

    return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TodoItemNode();

      node.sourceName = key;

      if (value != null) {
        if (typeof value === "object") {
          node.children = this.buildFileTree(value, level + 1);
        } else {
          node.sourceName = value;
        }
      }
      return accumulator.concat(node);
    }, []);
  }

  /** Add an item to to-do list */
  insertItem(parent: TodoItemNode, name: string) {
    if (parent.children) {
      parent.children.push({ sourceName: name } as TodoItemNode);
      this.dataChange.next(this.data);
    }
  }

  updateItem(node: TodoItemNode, name: string) {
    node.sourceName = name;
    this.dataChange.next(this.data);
  }

  public deleteItem(parent: TodoItemNode, name: string): void {
    console.log("parent");
    console.log(parent);
    console.log(parent.children);
    if (parent.children) {
      parent.children = parent.children.filter((c) => c.sourceName !== name);
      console.log("data");
      console.log(this.data);
      this.dataChange.next(this.data);
    }
  }
}

@Component({
  selector: "app-api-group",
  templateUrl: "./api-group.component.html",
  styleUrls: ["./api-group.component.scss"],
})
@Injectable()
export class ApiGroupComponent {
  entity: any;
  entityselected = [];
  created_By: any;
  haveEntity: boolean;
  isGroupExists: boolean;
  parentNode: any;
  parentFlat: any;
  gId: any;
  deleteNode: any;
  inputJson: any;
  apiRequestData: any;
  selectedLanguage: string;
  hardcodedOptions: string[] = ["C#", "Python", "Php", "Java"];
  ChooseLanguage = false;

  apiGroup = new FormGroup({
    groupId: new FormControl(),
    Name: new FormControl(),
    Entities: new FormControl(),
    Api: new FormControl(),
    Url: new FormControl(),
    InputJson: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();
  /** A selected parent node to be inserted */
  selectedParent: TodoItemFlatNode | null = null;

  /** The new item's name */
  newItemName = "";

  treeControl: FlatTreeControl<TodoItemFlatNode>;

  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;

  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(
    true /* multiple */
  );

  constructor(
    private router: Router,
    private _database: ChecklistDatabase,
    private daoService: DaoService,
    private fb: FormBuilder,
    private token: LstorageService,
    private spinner: SpinnerService,
    private spin: SpinnerComponent,
    private toast: ToastService,
    public dialog: MatDialog
  ) {
    this.selectedLanguage = "C#";

    this.spinner.show();
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(
      this.getLevel,
      this.isExpandable
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );

    this.created_By = jwtDecode(this.token.getToken());

    _database.dataChange.subscribe((data) => {
      this.dataSource.data = data;
    });

    //  For Entity
    // this.daoService.getEntity().subscribe((data) => {
    //   this.daoService.defaultEntityList(data);
    //   this.daoService.finalEntityList.subscribe(
    //     (entityList) => (this.entity = entityList)
    //   );
    //   this.spinner.hide();
    // });

    this.daoService.getEntities().subscribe((data) => {
      var dcrptdData = JSON.parse(decryptData(data.key));
      this.daoService.defaultEntityList(dcrptdData);
      this.daoService.finalEntityList.subscribe(
        (entityList) => (this.entity = entityList)
      );
      console.log("EntityName", dcrptdData);
      this.spinner.hide();
    });
  }

  ngOnInit() {
    this.GetApiRequest();
    debugger;
    this.inputJson = JSON.stringify(sinput);
    this.haveEntity = false;
    this.isGroupExists = false;
    this.apiGroup = this.fb.group({
      groupId: [""],
      Name: ["", [Validators.required]],
      Entities: [""],
      Api: [""],
      Url: [""],
      InputJson: [""],
      isActive: ["true"],
      createdBy: [""],
      createdOn: ["2020-01-03T15:50:10.213Z"],
      modifiedBy: [""],
      modifiedOn: ["2020-01-03T15:50:10.213Z"],
    });

    this._database.initialize();
    //Get Api group by id;
    // this.gId = this.token.getGroupId();
    const GroupId = this.token.getGroupId();
    const GId = "G001";
    var data1 = {
      GroupId: GroupId,
    };
    console.log("groupId Value", encryptData(JSON.stringify(data1)));
    // if (this.gId) {
    this.daoService
      .getGroupById(encryptData(JSON.stringify(data1)))
      .subscribe((data: any) => {
        debugger;

        console.log("PrintEntity", data);
        let grp = JSON.parse(decryptData(data.key));
        console.log("userDetails", grp);
        if (grp.entities) {
          this.entityselected = grp.entities;
          this.token.saveSelectedEntity(this.entityselected);
        }
        //For use entity in Api

        this.apiGroup = this.fb.group({
          groupId: [grp.groupId],
          Name: [grp.name, Validators.required],
          Entities: [grp.entities],
          Api: [""],
          Url: [""],
          InputJson: [""],
          isActive: ["true"],
          createdBy: [""],
          createdOn: ["2020-01-03T15:50:10.213Z"],
          modifiedBy: [""],
          modifiedOn: ["2020-01-03T15:50:10.213Z"],
        });
      });
    //}
  }

  //Add group
  public addNewItem(node: TodoItemFlatNode) {
    debugger;
    this.token.clear();
    this.haveEntity = false;
    this.isGroupExists = false;
    this.spinner.show();
    this.apiGroup.value.createdBy = this.daoService.loggedUser.UserUniqueId;
    const GroupId = this.token.getGroupId();
    this.apiGroup.value.groupId = GroupId;
    this.apiGroup.value.Entities = JSON.stringify(this.apiGroup.value.Entities);
    if (
      this.apiGroup.value &&
      this.apiGroup.value.Name.trim() != "" &&
      this.entityselected.length > 0
    ) {
      if (this.apiGroup.value.groupId) {
        const parentNode = this.flatNodeMap.get(node);
        this.token.saveParentId(parentNode.apiId);
        console.log("parentNode", parentNode.apiId);
        console.log("this.apiGroup.value", this.apiGroup.value);
        this.token.saveSelectedEntity(this.apiGroup.value.Entities);
        this.daoService
          .saveGroup(encryptData(JSON.stringify(this.apiGroup.value)))
          .subscribe(
            (data: any) => {
              if (!data.isSuccess) {
                this.isGroupExists = true;
              }
              this.spinner.hide();
            },
            (err) => {
              console.log(err),
                (this.isGroupExists = true),
                this.spinner.hide();
            }
          );
        this.router.navigate(["/apiManager"]);
      } else {
        console.log("Entered Group update");
        this.token.saveSelectedEntity(this.apiGroup.value.Entities);
        this.daoService
          .saveGroup(encryptData(JSON.stringify(this.apiGroup.value)))
          .subscribe(
            (data: any) => {
              if (!data.isSuccess) {
                this.isGroupExists = true;
                this.spinner.hide();
              } else {
                var groupId = data.data.groupId;
                const parentNode = this.flatNodeMap.get(node);
                this.token.saveGroupId(groupId);
                this.token.saveParentId(parentNode.apiId);
                this.spinner.hide();
                // this.daoService.changeId(groupdata);
                this.router.navigate(["/apiManager"]);
              }
            },
            (err) => {
              console.log(err),
                (this.isGroupExists = true),
                this.spinner.hide();
            }
          );
      }
    } else {
      this.haveEntity = true;
      this.spinner.hide();
    }
  }

  saveGroup() {
    debugger;
    console.log("Entered Apigrupsave!!");
    this.haveEntity = false;
    this.isGroupExists = false;
    this.spinner.show();
    this.apiGroup.value.Entities = this.entityselected;
    if (this.apiGroup.value && this.apiGroup.value.Entities.length > 0) {
      if (this.apiGroup.value.groupId) {
        //For Edit
        this.daoService
          .saveGroup(encryptData(JSON.stringify(this.apiGroup.value)))
          .subscribe(
            (data: any) => {
              if (!data.IsSuccess) {
                this.isGroupExists = true;
              }
              this.toast.openSnackBar(
                "Api group updated successfully",
                "close"
              );
              this.spinner.hide();
              this.router.navigate(["/ApiGroup"]);
            },
            (err) => {
              console.log(err),
                (this.isGroupExists = true),
                this.spinner.hide();
            }
          );
      } else {
        //for Add
        this.apiGroup.value.Entities = JSON.stringify(
          this.apiGroup.value.Entities
        );
        console.log("Entered add group");
        this.daoService
          .saveGroup(encryptData(JSON.stringify(this.apiGroup.value)))
          .subscribe(
            (data: any) => {
              // if (!data.isSuccess) {
              //   this.isGroupExists = true;
              //   this.spinner.hide();
              // } else {
              //   this.toast.openSnackBar(
              //     "Api group added successfully",
              //     "close"
              //   );
              //   this.spinner.hide();
              //   this.router.navigate(["/ApiGroup"]);
              // }
              if (!data.IsSuccess) {
                this.isGroupExists = true;
              }
              this.toast.openSnackBar(
                "Api group updated successfully",
                "close"
              );
              this.spinner.hide();
              this.router.navigate(["/ApiGroup"]);
            },
            (err) => {
              console.log(err),
                (this.isGroupExists = true),
                this.spinner.hide();
            }
          );
      }
    } else {
      this.haveEntity = true;
      this.spinner.hide();
    }
  }

  public editApimanager(node: TodoItemFlatNode) {
    this.token.clear();
    const currentnode = this.flatNodeMap.get(node);
    console.log("Entered EditApiManager ");

    console.log("currentnode", currentnode);

    var parentId = currentnode.parentID;
    console.log("parentId : ", parentId);
    this.token.saveParentId(parentId);
    this.token.saveApiManagerId(currentnode.apiId);
    this.router.navigate(["/apiManager"]);
  }

  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  backtoApiList() {
    this.token.apiGroupclear();
    this.router.navigate(["/ApiGroup"]);
  }

  checkedentity(entity) {
    if (this.entityselected && this.entityselected.indexOf(entity.name) != -1) {
      return true;
    }
  }

  onChange(event, entity) {
    if (event) {
      this.entityselected.push(entity);
    } else {
      this.entityselected.splice(this.entityselected.indexOf(entity), 1);
    }

    this.apiGroup.value.Entities = this.entityselected;
    console.log(this.apiGroup.value);
  }

  getLevel = (node: TodoItemFlatNode) => node.level;
  isExpandable = (node: TodoItemFlatNode) => node.expandable;
  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;
  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;
  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) =>
    _nodeData.sourceName === "";

  transformer = (node: TodoItemNode, level: number) => {
    console.log("node transform");
    console.log(node);
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.sourceName === node.sourceName
        ? existingNode
        : new TodoItemFlatNode();

    flatNode.sourceName = node.sourceName;
    flatNode.level = level;
    flatNode.expandable = !!node.children.length;
    flatNode.apiId = node.apiId;

    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) =>
      this.checklistSelection.isSelected(child)
    );
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.every((child) => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    var elementPos = this.treeControl.dataNodes
      .map(function (x) {
        return x.apiId;
      })
      .indexOf(node.apiId);
    for (let i = elementPos; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  /** Save the node to database */
  saveNode(node: TodoItemFlatNode, itemValue: string) {
    const nestedNode = this.flatNodeMap.get(node);
    this._database.updateItem(nestedNode!, itemValue);
  }

  //Add Entity
  AddEntity(): void {
    debugger;
    //this.token.clearentityformId();
    const dialogRef = this.dialog.open(EntityformComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "442px",
      height: "210px",
      autoFocus: true,
    });

    // dialogRef.beforeClosed().subscribe((entityList) => {
    //   this.daoService.getEntity().subscribe((data) => {
    //     this.daoService.defaultEntityList(data);
    //     this.spinner.hide();
    //   });
    // });
    dialogRef.beforeClosed().subscribe((entityList) => {
      this.daoService.getEntities().subscribe((data) => {
        var dcrptdData = JSON.parse(decryptData(data.key));
        console.log("Entered Add Entity", data);
        this.daoService.defaultEntityList(dcrptdData);
        this.spinner.hide();
      });
    });
  }

  deleteApi(node: TodoItemFlatNode) {
    this.daoService.Apiid(node);
    this.daoService.ApiDelete(true);
    const dialogRef = this.dialog.open(UserdeleteComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "auto",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.ApiDelete(false);
    });
  }

  public deleteItem(): void {
    this.daoService.finalApiNode.subscribe(
      (apiId) => (this.deleteNode = apiId)
    );
    let node: TodoItemFlatNode = this.deleteNode;
    this.parentNode = this.getParentNode(node);
    this.parentFlat = this.flatNodeMap.get(this.parentNode);
    this._database.deleteItem(this.parentFlat!, this.deleteNode.sourceName);
    this.treeControl.expand(this.deleteNode);
  }

  public delete1(node: TodoItemFlatNode): void {
    this.daoService.Apiid(node);
    this.daoService.finalApiNode.subscribe(
      (apiId) => (this.deleteNode = apiId)
    );
    this.daoService
      .deleteApimanagerById(this.deleteNode.apiId)
      .subscribe((data: any) => {
        this.parentNode = this.getParentNode(this.deleteNode);
        this.parentFlat = this.flatNodeMap.get(this.parentNode);
        this._database.deleteItem(this.parentFlat!, this.deleteNode.sourceName);
        this.treeControl.expand(this.deleteNode);
      });
  }

  handleInput(event) {
    if (event.which === 32 && !this.apiGroup.value.Name.length)
      event.preventDefault();
  }
  GetApiRequest() {
    const GroupId = this.token.getGroupId();
    var data1 = {
      GroupId: GroupId,
    };
    //For Edit
    this.daoService
      .getApiRequestById(encryptData(JSON.stringify(data1)))
      .subscribe(
        (data: any) => {
          let apiData = JSON.parse(decryptData(data.key));

          console.log("apiReqData", apiData);
          if (!data.IsSuccess) {
            this.isGroupExists = true;
          }
          const apiReq = JSON.parse(apiData.key);
          // this.toast.openSnackBar(
          //   "Api group updated successfully",
          //   "close"
          // );
          this.apiRequestData = JSON.stringify(apiReq, null, 2).replace(
            /\\/g,
            ""
          );
          this.spinner.hide();
          //this.router.navigate(["/ApiGroup"]);
        },
        (err) => {
          console.log(err), (this.isGroupExists = true), this.spinner.hide();
        }
      );
  }
  languagechange(event) {
    console.log("LanguageChange", event);
    console.log("Json", this.apiRequestData);
    this.ChooseLanguage = true;
    var CodeConvert = {
      JsonStructure: this.apiRequestData,
      TargetLanguage: event,
    };
    this.daoService
      .openAIJsonConvertion(encryptData(JSON.stringify(CodeConvert)))
      .subscribe(
        (data: any) => {
          let apiData = JSON.parse(decryptData(data.key));

          console.log("apiReqData", apiData);
          if (!data.IsSuccess) {
            this.isGroupExists = true;
          }
          const apiReq = JSON.parse(apiData.key);
          // this.toast.openSnackBar(
          //   "Api group updated successfully",
          //   "close"
          // );
          this.apiRequestData = JSON.stringify(apiReq, null, 2).replace(
            /\\/g,
            ""
          );
          this.spinner.hide();
          //this.router.navigate(["/ApiGroup"]);
        },
        (err) => {
          console.log(err), (this.isGroupExists = true), this.spinner.hide();
        }
      );
  }
}
